import { render, staticRenderFns } from "./HollowPie.vue?vue&type=template&id=8b0dd728&"
import script from "./HollowPie.vue?vue&type=script&lang=js&"
export * from "./HollowPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports